import React from "react";
import { AppBar as AppBarMui, Toolbar, Hidden, Box, Typography, Stack } from "@mui/material";
import { ReactComponent as Logo } from "../../assets/white_logo.svg";
import { styled } from "@mui/material/styles";
import { Message } from "@mui/icons-material";
import { useHistory } from "react-router-dom";
import { Auth } from "aws-amplify";
import { user as userVar } from "../../apollo/cache";
import { useTranslation } from "react-i18next";
import Beta from "./Beta";
import useBeta from "hook/useBeta";
import DrawerBeta from "./Beta/DrawerBeta";
import MenuService, { ButtonNavbar } from "./MenuService";
import MenuLanguage from "./MenuLanguage";
import MenuDrawer from "./MenuDrawer";
import MenuHelp from "./MenuHelp";
import MenuNotification from "./MenuNotification";
import useContact from "./Contact";
// import DialogNewFeature from "components/DialogNewFeature";

import ReactGA from "react-ga4";
import { WhatIsNewFullScreen } from "sections/whatIsNew";
import MenuProfile from "./MenuProfile";
import { useReactiveVar } from "@apollo/client";
import { APP_VERSION } from "config";
import { useSelector } from "redux/store";
import { selectPermissionAction } from "redux/slices/role";

const IAppBar = styled(AppBarMui)(({ theme, isUsedBeta }) => ({
  background: !isUsedBeta ? theme.palette.primary.contrastText : theme.palette.primary.main,
  color: !isUsedBeta ? theme.palette.primary.main : theme.palette.primary.contrastText,
  "--color-text": !isUsedBeta ? theme.palette.primary.main : theme.palette.primary.contrastText,
  "--color-version": !isUsedBeta ? theme.palette.warning.main : theme.palette.primary.contrastText,
  "--background-color-hover": !isUsedBeta
    ? "#F2F9EF"
    : "linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), #1F7B44",
  height: "74px",
  justifyContent: "center",
  width: "100%",
  [theme.breakpoints.down("sm")]: {
    height: "50px",
  },
  boxSizing: "border-box",
  zIndex: 1000,
  boxShadow: "0px 4px 60px 0px #00000014",
}));
const WrapperLeft = styled(`div`)(() => ({
  flexGrow: 1,
}));
const WrapperLogoGroup = styled(`div`)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  fontSize: "1.375rem",
  boxSizing: "border-box",
  cursor: "pointer",
  fontWeight: 600,
  width: "fit-content",
  [theme.breakpoints.down("sm")]: {
    fontSize: "1rem",
  },
}));
const StyledSVG = styled(Logo)`
  width: 40px;
  height: 40px;
  margin-right: 18px;
  & path {
    fill: var(--color-text);
  }
`;

const BoxVersion = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 2px 10px;
  // border: 2px solid var(--color-version);
  border: 2px solid #1f7b44;
  box-sizing: border-box;
  border-radius: 8px;
  color: var(--color-version);
  height: 40px;
`;

const AppBar = ({ isAuth = false }) => {
  const user = useReactiveVar(userVar);
  const { t } = useTranslation(["translation"]);
  const history = useHistory();
  const { isBeta, isUsedBeta } = useBeta();
  const isAllowNotification = useSelector(selectPermissionAction)("notification:view");
  const [openNewFeature, setOpenNewFeature] = React.useState(false);
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const { handleContact } = useContact();

  const signOut = async () => {
    try {
      await Auth.signOut();
      userVar({});
      window.location.reload();
      history.push("/login");
    } catch (error) {
      alert(`logout fail!`);
    }
  };

  return (
    <>
      <IAppBar position="fixed" isUsedBeta={isUsedBeta}>
        <Toolbar>
          <WrapperLeft>
            <Stack direction="row" spacing={2} alignItems={"center"}>
              <WrapperLogoGroup
                onClick={() => {
                  history.push("/mainmenu");
                  ReactGA.event("click_navigation", {
                    component: "navbar",
                    link: "mainmenu",
                    label: "logo",
                  });
                }}
              >
                <StyledSVG />
                <Hidden mdDown>
                  <div>{t("appbar.label")}</div>
                </Hidden>
                <Hidden mdUp>
                  <div>M0</div>
                </Hidden>
              </WrapperLogoGroup>
              <Hidden mdDown>
                <BoxVersion
                  sx={{ ml: "16px", cursor: "pointer" }}
                  onClick={() => {
                    setOpenNewFeature(true);
                    // handleOpen();
                    ReactGA.event("click_navigation", {
                      component: "navbar",
                      link: "new feature",
                      label: "version",
                    });
                  }}
                >
                  <Typography variant="subtitle2" color="#1f7b44;">
                    {isUsedBeta && "BETA"} v{APP_VERSION}
                  </Typography>
                </BoxVersion>
              </Hidden>
              {isAuth && isAllowNotification && <MenuNotification />}
            </Stack>
          </WrapperLeft>

          <Hidden mdDown>
            {isAuth && (
              <>
                {/* {isFeature.dashboard && (
                  <ButtonNavbar
                    startIcon={<BarChart />}
                    variant="text"
                    component={Link}
                    to="/dashboard"
                  >
                    {t("appbar.statisticalData")}
                  </ButtonNavbar>
                )} */}
                <MenuService />
                <MenuHelp />
              </>
            )}
            {!isAuth && <MenuLanguage />}
            <ButtonNavbar
              id="appbar-button-contact"
              startIcon={<Message />}
              variant="text"
              onClick={() => {
                handleContact();
                ReactGA.event("click_navigation", {
                  component: "navbar",
                  link: "contact",
                });
              }}
            >
              {t("appbar.contact")}
            </ButtonNavbar>
            {isAuth && (
              <>
                <MenuLanguage />
                <MenuProfile
                  profile={{
                    username: user.attributes?.name || user.username,
                    email: user.attributes?.email,
                  }}
                  signOut={signOut}
                />
                {isBeta && (
                  <Box sx={{ ml: 1 }}>
                    <Beta onSubmit={() => setOpenDrawer(true)} />
                  </Box>
                )}
              </>
            )}
          </Hidden>

          <Hidden mdUp>
            <MenuLanguage />
            <MenuDrawer
              username={user?.username}
              handleContact={handleContact}
              isBeta={isBeta}
              isUsedBeta={isUsedBeta}
              setOpenDrawer={setOpenDrawer}
              signOut={signOut}
              isAuth={isAuth}
            />
          </Hidden>
        </Toolbar>
      </IAppBar>
      <Box sx={{ height: { xs: 50, sm: 74 } }} />
      <DrawerBeta open={openDrawer} onClose={() => setOpenDrawer(false)} />
      {openNewFeature && (
        <WhatIsNewFullScreen open={openNewFeature} handleClose={() => setOpenNewFeature(false)} />
      )}
    </>
  );
};

export default AppBar;
